<template>
  <div style="width: 100%">
    <v-row>
      <v-col cols="12">
        <areas-perfil-select
          :areas="perfil.areasCultura"
          :lista="listaAreasCultura"
          :instrutor="perfil.instrutorCultura"
          :maximo-areas="5"
          :maximo-cursos="5"
          tipo="CULTURA"
          icone="palette"
          permite-criar-area
          @return="(value) => saveAreasCultura(value)"
          @confirm="(value) => saveInstrutorCultura(value)"
        />
      </v-col>
      <v-col cols="12">
        <areas-perfil-select
          :areas="perfil.areasEsporte"
          :lista="listaAreasEsporte"
          :instrutor="perfil.instrutorEsporte"
          :maximo-areas="5"
          :maximo-cursos="5"
          tipo="ESPORTE"
          icone="directions_bike"
          permite-criar-area
          @return="(value) => saveAreasEsporte(value)"
          @confirm="(value) => saveInstrutorEsporte(value)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AreasPerfilSelect from '@/components/perfil/AreasPerfilSelect';

export default {
  name: 'AtividadesInteresse',

  components: { AreasPerfilSelect },

  props: {
    perfil: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
  },

  computed: {
    ...mapState({
      listaAreasCultura: (state) => state.perfil.listaAreasCultura,
      listaAreasEsporte: (state) => state.perfil.listaAreasEsporte,
    }),
  },

  methods: {
    saveAreasCultura(areas) {
      this.perfil.areasCultura = areas;
      this.updatePerfil();
    },
    saveInstrutorCultura(instrutor) {
      this.perfil.instrutorCultura = instrutor;
      this.updatePerfil();
    },
    saveAreasEsporte(areas) {
      this.perfil.areasEsporte = areas;
      this.updatePerfil();
    },
    saveInstrutorEsporte(instrutor) {
      this.perfil.instrutorEsporte = instrutor;
      this.updatePerfil();
    },
    updatePerfil() {
      if (this.perfil && this.perfil.areasCultura.length <= 5 && this.perfil.areasEsporte.length <= 5) {
        this.$emit('updatePerfil', this.perfil);
      }
    },
  },
};
</script>
